(function () {
  const CONTROLLER_KEY = '_happyCustomersSlider';

  class HappyCustomersSlider {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-happy-track]');
      this.abortController = new AbortController();
      this.signal = this.abortController.signal;
      this.dragging = false;
      this.startX = 0;
      this.startScroll = 0;
      this.moved = false;

      if (!this.track) return;
      this.bindEvents();
    }

    bindEvents() {
      const { signal } = this;

      this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
      this.track.addEventListener('pointermove', (event) => this.onPointerMove(event), { signal });
      this.track.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
      this.track.addEventListener('pointercancel', (event) => this.onPointerUp(event), { signal });
      this.track.addEventListener(
        'click',
        (event) => {
          if (this.moved) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        { capture: true, signal }
      );
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('.happy-customers__control')) return;

      this.dragging = true;
      this.moved = false;
      this.startX = event.clientX;
      this.startScroll = this.track.scrollLeft;
      this.track.classList.add('is-dragging');
      this.track.setPointerCapture?.(event.pointerId);
    }

    onPointerMove(event) {
      if (!this.dragging) return;
      const delta = event.clientX - this.startX;
      if (Math.abs(delta) > 6) this.moved = true;
      this.track.scrollLeft = this.startScroll - delta;
    }

    onPointerUp(event) {
      if (!this.dragging) return;
      this.dragging = false;
      this.track.classList.remove('is-dragging');
      try {
        this.track.releasePointerCapture?.(event.pointerId);
      } catch (error) {
        // Capture may already be released.
      }
    }

    destroy() {
      this.abortController.abort();
    }
  }

  function initHappyCustomersSliders(scope) {
    const roots = (scope || document).querySelectorAll('[data-happy-slider]');
    roots.forEach((root) => {
      if (root[CONTROLLER_KEY]) {
        root[CONTROLLER_KEY].destroy();
        root[CONTROLLER_KEY] = null;
      }
      root[CONTROLLER_KEY] = new HappyCustomersSlider(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initHappyCustomersSliders(document));
  document.addEventListener('shopify:section:load', (event) => initHappyCustomersSliders(event.target));
  document.addEventListener('shopify:section:reorder', () => initHappyCustomersSliders(document));

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initHappyCustomersSliders(document);
  }
})();
